import { styled } from "@mui/system";
import {
	Accordion,
	AccordionSummary,
	accordionSummaryClasses,
} from "@mui/material";

export const EventSessionAccordion = styled(Accordion)(({ theme }) => ({
	marginTop: "0 !important",
	border: `1px solid ${theme.palette.divider}`,
	overflow: "hidden",
	borderRadius: `${theme.spacing(1.5)} !important`,
	[theme.breakpoints.down("md")]: {
		backgroundColor: "#F4F6F8 !important",
	},
	"&:before": {
		backgroundColor: "unset",
	},
	[`&.${accordionSummaryClasses.expanded}`]: {
		marginBottom: "0 !important",
		boxShadow: {
			xs: "none",
			md: "0 8px 16px 0 rgba(145 158 171 / 0.16)",
		},
	},
}));

export const EventSessionAccordionSummary = styled(AccordionSummary)(
	({ theme, isError = false }) => ({
		backgroundColor: isError
			? "rgba(255, 86, 48, 0.12)"
			: "rgba(145, 158, 171, 0.08)",
		border: `1px solid ${isError ? "#F04438" : "transparent"}`,
		marginTop: 0,
		marginBottom: 0,
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5),
		borderRadius: theme.spacing(1.5),
		minHeight: `${theme.spacing(6)} !important`,
		alignItems: "center",
		[theme.breakpoints.down("md")]: {
			alignItems: "flex-start"
		},
		[`& .${accordionSummaryClasses.content}`]: {
			marginTop: "0 !important",
			marginBottom: "0 !important",
		},
		[`& .${accordionSummaryClasses.expanded}`]: {
			marginTop: "0 !important",
			marginBottom: "0 !important",
		},
		[`&.${accordionSummaryClasses.expanded}`]: 	{
			borderRadius: `${theme.spacing(1.5)} ${theme.spacing(1.5)} 0 0 !important`,
		},
	}),
);
